export const DragTypes = {
  SCHOOL_PICKER: 'School Picker'
};

export default DragTypes;
